<template>
    <button
        type="button"
        role="radio"
        class="general-button rounded-corners"
        :class="{ 'selected-sorted': checked }"
        :aria-checked="checked ? 'true' : 'false'"
        :tabindex="tabindex"
        @click="select"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: Number,
            default: -1,
        },
    },
    emits: [ 'select' ],
    methods: {
        select( event ) {
            this.$emit( 'select', event );
        },
    },
};
</script>
